import { Component, MasterPageDefinition } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'

export const accessibilityStyle = createCssCompNode('accessibility', 'accessibilityStyle', {
	getDependencies: (component: Component, refs: FeatureRefs<'accessibility'>) => {
		return component.type === 'Document' ? refs.dataQuery<MasterPageDefinition['data']>(component.dataQuery!) : null
	},
	toViewItem: (__, deps): boolean => {
		// For all components except the master page, we don't want to render the accessibility style
		if (!deps) {
			return false
		}

		// Checking if the master page has accessibility settings and if the visual focus is disabled
		// Sometimes we don't have accessiblitySettings on Mobile and then we need to consider that in our logic
		return !(deps.accessibilitySettings?.visualFocusDisabled === true)
	},
})
